import { BaseResponse } from '@/types';
import { BaseApiService } from './base-service';

export class FileService extends BaseApiService {
  async getFile(params: Record<string, null | boolean | string | number | string[] | number[]>): Promise<Blob | null> {
    try {
      const { data } = await this.http_client.get<BaseResponse | Blob>('file', {
        params,
        responseType: 'blob',
      });

      return data instanceof Blob ? data : null;
    } catch (error) {
      return null;
    }
  }
}
